import {
  Box,
  Grow,
  List,
  ListItem,
  ListItemButton,
  Tooltip,
  useTheme,
} from "@mui/material";
import { JSX, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import uniqid from "uniqid";
import useOnClickOutside from "use-onclickoutside";
import { AppConfig } from "../../Config/app-config";
import { ChatbotConsoleService } from "../../Services/Apis/ChatbotConsoleService";
import { getProjectConfigFn } from "../../Services/Apis/CoreApis";
import { CORE_ENDPOINTS } from "../../Services/Apis/Endpoints";
import { useAppSelector } from "../../Store";
import { useAuthStore } from "../../Store/Slices/AuthSlice";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { domainDetails } from "../../Store/Slices/SubAccount/subaccount.selectors";
import {
  ChangeSelectedBot,
  useCurrentBot,
} from "../../Store/Slices/DashboardSlices";
import { formatString, isEmptyObject } from "../../Utils";
import {
  detectIdPlaceholder,
  getSelectedMenuObject,
} from "../../Utils/menuUtils";
import { HelpMenuStyles, LeftMenuWrap, MenuStyles } from "./MenuStyle";
import { theme } from "../../Customization/Theme";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// import logo from "../../assets/images/wabo_circle_v2.svg";
import getPublicAssets from "../../Services/s3bucket";
import { AnyAaaaRecord } from "dns";
import { LeftBottomMenuOptions } from "../../Models/defaultSelectOptions";
const logo = getPublicAssets("icons/wabo_circle_v2.svg");

const LeftMenu = (props: any): JSX.Element => {
  const theme = useTheme();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const currentBot = useAppSelector(useCurrentBot);
  const { userConfig }: any = useAppSelector(useAuthStore);
  const isWhatsappConfigured: any =
    userConfig?.payload?.whatsapp_enabled ?? false;
  var [selectedIndex, setSelectedIndex] = useState<any>("");
  var [renderSubMenu, setRenderSubMenu] = useState<any>("");
  var [renderMoreSectionMenu, setRenderMoreSectionMenu] =
    useState<boolean>(false);
  const [maxIcons, setMaxIcons] = useState<number>(6);
  var [nestedMenuModule, setNestedMenuModule] = useState<any>("");
  const iconRef = useRef<HTMLDivElement>(null);
  var [parentId, setParentId] = useState<string>("");
  const workspace_id: string = window.localStorage.getItem("ws_id") || "";
  const domainDetailsData = useAppSelector(domainDetails);

  // const getBotDataIfExitsInUrl = () => {
  //   const botId = AppConfig.getLoggedInData()?.data?.user.bots[0];
  //   botId &&
  //     !currentBot?.bot_id &&
  //     ChatbotConsoleService.getBotById({ bot_id: botId }).then((response) => {
  //       const bot = response.data;
  //       dispatch(ChangeSelectedBot(response.data));
  //       const proj_v_url = formatString(CORE_ENDPOINTS.PROJECT_VER_CONFIG, [
  //         bot.project_version_id,
  //       ]);
  //       getProjectConfigFn(dispatch)({ url: proj_v_url }).then(
  //         (res: any) => {}
  //       );
  //     });
  // };

  const getCurrentPathAfterRefresh = () => {
    //* HARDCODING THIS VALUE BECAUSE CHANGING THIS REQUIRES A LOT OF CHANGES IN THE MULTIPLE FILES //
    if (location.pathname.indexOf("/setup") >= 0) {
      // getBotDataIfExitsInUrl();
      return setSelectedIndex("setup");
    }
    if (location.pathname.indexOf("/settings") >= 0) {
      return setSelectedIndex("settings");
    }
    if (location.pathname.indexOf("/subscription") >= 0) {
      return setSelectedIndex("subscription");
    }
    if (
      location.pathname.indexOf("/whatsapp/templates") >= 0 ||
      location.pathname.indexOf("/whatsapp/default_template") >= 0
    ) {
      return setSelectedIndex("templates");
    }
    if (location.pathname.indexOf("/whatsapp/flow") >= 0) {
      return setSelectedIndex("whatsapp-flow");
    }

    let SelectedMenu = getSelectedMenuObject(
      userConfig?.payload?.menu_items?.left_top_menu_options,
      location.pathname
    );

    if (!SelectedMenu) {
      SelectedMenu = getSelectedMenuObject(
        userConfig?.payload?.menu_items?.left_bottom_menu_options,
        location.pathname
      );
    }

    if (SelectedMenu) {
      setSelectedIndex(SelectedMenu?.value);
    }
  };

  useEffect(() => {
    const updateMaxIcons = () => {
      const menuHeight = iconRef.current?.clientHeight || window.innerHeight; // Replace with specific menu height if needed
      const iconHeight = 150; // Height of each icon including padding/margin
      const visibleIcons = Math.floor(menuHeight / iconHeight);
      if (visibleIcons == memoizedTopMenuOptions.length - 1) {
        setMaxIcons(visibleIcons + 1);
      } else {
        setMaxIcons(visibleIcons);
      }
    };

    window.addEventListener("resize", updateMaxIcons);
    updateMaxIcons(); // Initial call

    return () => window.removeEventListener("resize", updateMaxIcons);
  }, []);

  const memoizedTopMenuOptions = useMemo(() => {
    const permissionsData: any =
      userConfig?.payload?.allowed_permissions ?? null;
    if (isEmptyObject(permissionsData)) return;

    const result = userConfig?.payload?.menu_items?.left_top_menu_options ?? [];

    return result;
  }, [userConfig?.payload?.menu_items?.left_top_menu_options]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getCurrentPathAfterRefresh();
    setNestedMenuModule("");
  }, [memoizedTopMenuOptions, location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleListItemClick = (curElem: any, nestedMenu: boolean = false) => {
    setParentId(curElem.value);

    if (curElem?.children?.length > 0) {
      setRenderSubMenu(true);
      if (nestedMenu) {
        setNestedMenuModule(curElem.value);
      }
      return;
    }

    if (curElem?.value === "setup") {
      const subUrl = `/workspace/{0}/setup/bots`;

      const url = formatString(subUrl, [workspace_id]);
      navigate(url);
      closeMenu();
      return;
    }

    renderSubMenu && setRenderSubMenu(false);
    const subUrl = curElem?.url;
    navigate(subUrl);
    closeMenu();
  };

  const handleChildrenItemClick = (curElem: any, parent: any) => {
    setRenderSubMenu(curElem?.value);

    const subUrl = curElem.url;
    navigate(subUrl);
    closeMenu();
  };

  const redirectToHome = () => {
    // const subUrl = "/analytics/dashboard";
    // const subUrl = "/";
    // navigate(subUrl);

    const whatsappConfigured = userConfig?.payload?.whatsapp_enabled ?? false;
    if (whatsappConfigured) {
      navigate("/");
    } else {
      navigate("/onboarding/welcome", { replace: true });
    }
  };

  const closeMenu = () => {
    setRenderSubMenu(false);
    setRenderMoreSectionMenu(false);
    setNestedMenuModule("");
  };

  const MenuItem = ({ item, handleItemClick, id }: any) => {
    if (!item.isAvailable) return null;

    return (
      <ListItemButton
        id={id || ""}
        key={item.value}
        className="listItem"
        selected={location.pathname.includes(item.url)}
        onClick={(event: any) => {
          event.preventDefault();
          handleItemClick(item, true);
        }}
        disabled={item.isDisabled}
        component={Link}
        to={item?.url}
        sx={{
          textAlign: "center",
          "&:hover": {
            background: theme.palette.primary.dark,
          },
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.dark,
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          },
        }}
      >
        {item.icon ? (
          <img
            loading="lazy"
            style={{
              height: "18px",
              width: "18px",
              margin: "0px 10px 0 4px",
            }}
            src={item.icon}
            alt={item.label}
          />
        ) : null}
        {item.label}
        {/* Render children if available */}
        {item.children && item.children.length > 0 && (
          <ChevronRightIcon
            sx={{
              paddingLeft: "5px",
              fontSize: "32px",
              fontWeight: "bold",
            }}
          />
        )}
        {item?.children && item?.value == nestedMenuModule && (
          <MenuStyles style={{ marginLeft: "120px" }}>
            {item.children.map((child: { value: any }) => (
              <MenuItem
                key={child.value}
                item={child}
                handleItemClick={handleItemClick}
              />
            ))}
          </MenuStyles>
        )}
      </ListItemButton>
    );
  };

  const ref = useRef<any>(null);
  useOnClickOutside(ref, closeMenu);

  const accountType = userConfig?.payload?.reseller_details ?? "";

  const brandLogo =
    !accountType &&
    window.location.hostname === process.env.REACT_APP_DOMAIN_NAME
      ? getPublicAssets("icons/wabo_circle_v2.svg")
      : domainDetailsData?.logo;

  return (
    <LeftMenuWrap>
      <Box className="leftTopMenu">
        <img
          loading="lazy"
          src={brandLogo}
          onClick={() => redirectToHome()}
          alt="logo"
        />
        <Box className="leftMenuWrapper">
          <List style={{ opacity: isWhatsappConfigured ? 1 : 0.5 }}>
            {memoizedTopMenuOptions &&
              memoizedTopMenuOptions.length > 0 &&
              memoizedTopMenuOptions
                ?.slice(0, maxIcons)
                ?.map((curElem: any, index: number) => {
                  if (!curElem?.isAvailable) return null;
                  return (
                    <ListItem key={index} className="menuItem">
                      <ListItemButton
                        key={index}
                        selected={selectedIndex === curElem.value}
                        id={`menu-icon-${curElem.value}`}
                        onClick={(event: any) => {
                          event.preventDefault(); // This will prevent the link from navigating
                          handleListItemClick(curElem);
                        }}
                        disabled={!isWhatsappConfigured ?? curElem?.isDisabled}
                        component={Link}
                        to={
                          detectIdPlaceholder(curElem?.url)
                            ? formatString(curElem?.url, [workspace_id])
                            : curElem?.url
                        }
                        sx={{
                          textAlign: "center",
                          "&:hover": {
                            background: theme.palette.primary.dark,
                          },
                          "&.Mui-selected": {
                            backgroundColor: theme.palette.primary.dark, // Change the background color when selected
                            "&:hover": {
                              backgroundColor: theme.palette.primary.dark, // Change the background color on hover for selected items
                            },
                          },
                        }}
                        className="menuButton"
                        disableRipple
                      >
                        <img
                          loading="lazy"
                          alt="img_menu"
                          style={{ width: "20px", height: "20px" }}
                          src={curElem?.icon ?? "null"}
                        />
                        <p className="anchor-text">{curElem?.label}</p>
                      </ListItemButton>

                      <MenuStyles
                        ref={ref}
                        style={{
                          display:
                            renderSubMenu && parentId === curElem?.value
                              ? "block"
                              : "none",
                          visibility:
                            renderSubMenu && parentId === curElem?.value
                              ? "visible"
                              : "hidden",
                        }}
                      >
                        {curElem?.children?.map((child: any) => {
                          if (!child?.isAvailable) return null;
                          return (
                            <ListItemButton
                              key={uniqid()}
                              className="listItem"
                              id={`sub-menu-icon-${parentId}-${child.value}`}
                              selected={location?.pathname?.includes(
                                child?.url
                              )}
                              onClick={(event: any) => {
                                event.preventDefault(); // This will prevent the link from navigating
                                handleChildrenItemClick(child, curElem);
                              }}
                              disabled={child.isDisabled}
                              component={Link}
                              to={child?.url}
                              sx={{
                                textAlign: "center",
                                "&:hover": {
                                  background: theme.palette.primary.dark,
                                },
                                "&.Mui-selected": {
                                  backgroundColor: theme.palette.primary.dark, // Change the background color when selected
                                  "&:hover": {
                                    backgroundColor: theme.palette.primary.dark, // Change the background color on hover for selected items
                                  },
                                },
                              }}
                            >
                              {child?.icon ? (
                                <img
                                  loading="lazy"
                                  style={{
                                    height: "18px",
                                    width: "18px",
                                    margin: "0px 10px 0 4px",
                                  }}
                                  src={child?.icon}
                                  alt={child?.label}
                                />
                              ) : null}
                              {child?.label}
                            </ListItemButton>
                          );
                        })}
                      </MenuStyles>
                    </ListItem>
                  );
                })}
            {memoizedTopMenuOptions &&
              memoizedTopMenuOptions.length > maxIcons && (
                <>
                  <ListItem key={"more-btn"} className="menuItem">
                    {/* Check if there is any available child in the slice from index 6 to 12 */}
                    <ListItemButton
                      sx={{
                        textAlign: "center",
                        "&:hover": {
                          background: theme.palette.primary.dark,
                        },
                        "&.Mui-selected": {
                          backgroundColor: theme.palette.primary.dark, // Change the background color when selected
                          "&:hover": {
                            backgroundColor: theme.palette.primary.dark, // Change the background color on hover for selected items
                          },
                        },
                      }}
                      className="menuButton"
                      disableRipple
                      id="more-section-leftmenu"
                      onClick={() =>
                        setRenderMoreSectionMenu(!renderMoreSectionMenu)
                      }
                      disabled={!isWhatsappConfigured}
                    >
                      <MoreHorizIcon />
                    </ListItemButton>
                    <MenuStyles
                      ref={ref}
                      style={{
                        display: renderMoreSectionMenu ? "block" : "none",
                      }}
                    >
                      {memoizedTopMenuOptions
                        .slice(maxIcons)
                        .map((item: { value: any }) => (
                          <MenuItem
                            id={`menu-icon-${item.value}`}
                            key={item.value}
                            item={item}
                            handleItemClick={handleListItemClick}
                          />
                        ))}
                    </MenuStyles>
                  </ListItem>
                </>
              )}
          </List>
          <List style={{ display: "flex", alignItems: "end", bottom: "0" }}>
            {LeftBottomMenuOptions &&
              LeftBottomMenuOptions?.length > 0 &&
              LeftBottomMenuOptions.map((curElem: any, index: number) => {
                if (!curElem?.isAvailable) return null;
                return (
                  <ListItem key={index} className="menuItem">
                    <ListItemButton
                      selected={selectedIndex === curElem.value}
                      onClick={() => handleListItemClick(curElem)}
                      id={`bottom-menu-${curElem.value}`}
                      disabled={curElem?.isDisabled ?? false}
                      sx={{
                        textAlign: "center",
                        "&:hover": {
                          background: theme.palette.primary.dark,
                        },
                        "&.Mui-selected": {
                          backgroundColor: theme.palette.primary.dark,
                          "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                          },
                        },
                      }}
                      className="menuButton"
                      disableRipple
                    >
                      <img
                        alt="img_menu"
                        style={{ width: "20px", height: "20px" }}
                        src={curElem?.icon ?? "null"}
                      />
                      <p className="anchor-text">{curElem?.label}</p>
                    </ListItemButton>
                    {renderSubMenu &&
                    parentId === curElem?.value &&
                    curElem?.children?.length ? (
                      <HelpMenuStyles ref={ref}>
                        {curElem?.children.map((child: any) => {
                          if (!child?.isAvailable) return null;

                          return (
                            <ListItemButton
                              key={uniqid()}
                              className="listItem"
                              selected={
                                selectedIndex === child.value ||
                                window.location?.pathname === child?.url
                              }
                              target="_blank"
                              onClick={(event: any) => {
                                handleChildrenItemClick(child, curElem);
                              }}

                              disabled={child.isDisabled}
                              component={Link}
                              to={child?.url}
                              sx={{
                                textAlign: "left",
                                "&:hover": {
                                  background: theme.palette.primary.dark,
                                },
                                "&.Mui-selected": {
                                  backgroundColor: theme.palette.primary.dark, // Change the background color when selected
                                  "&:hover": {
                                    backgroundColor: theme.palette.primary.dark, // Change the background color on hover for selected items
                                  },
                                },
                              }}
                              id={`bottom-menu-${child.value}`}
                            >
                              {child?.icon ? (
                                <img
                                  loading="lazy"
                                  style={{
                                    height: "18px",
                                    width: "18px",
                                    margin: "0px 10px 0 4px",
                                  }}
                                  src={child?.icon}
                                  alt={child?.label}
                                />
                              ) : null}
                              {child?.label}
                            </ListItemButton>
                          );
                        })}
                      </HelpMenuStyles>
                    ) : null}
                  </ListItem>
                );
              })}
          </List>
        </Box>
      </Box>
    </LeftMenuWrap>
  );
};

export default LeftMenu;
